import { connect } from 'react-redux';
import { mapStateToProps } from '../cart-item/cart-item-control.selector';
import { MobileItemControl as Component } from './mobile-item-control';
export const MobileItemControl = connect(mapStateToProps, null)(Component);